import { render } from "./AddQwilrDefinitionTemplate.vue?vue&type=template&id=33c77a9e&scoped=true"
import script from "./AddQwilrDefinitionTemplate.vue?vue&type=script&lang=js"
export * from "./AddQwilrDefinitionTemplate.vue?vue&type=script&lang=js"

import "./AddQwilrDefinitionTemplate.vue?vue&type=style&index=0&id=33c77a9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c77a9e"]])

export default __exports__